import React from 'react'
import "./noData.scss";
class noData extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  async componentDidMount() {

  }
  render() {
    const { width, height } = this.props
    return <div component-data="noData">
      <img style={{width, height}} src={require("../../../img/pinzhunzhun/dataSource/noData.svg")} />
    </div>
  }
}

export default noData;